import comp from "./CasVisitorSignup";
export default comp;
